import { Box, Flex, Grid, Text, VStack } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';
import { BrandBlock } from './BrandBlock';
import { Copyright } from './Copyright';
import { FooterLinkItem } from './FooterLinkItem';
import { LINK_GROUPS } from './footerLinks';
import { HEADING } from './footerStyles';

export const FooterDesktop = () => (
  <Flex direction='column' w='100%' maxW='container.xl' mx='auto'>
    <Flex w='100%' align='flex-start' justify='space-between' gap={{ md: 10, lg: 16 }}>
      <BrandBlock />
      <Grid
        templateColumns='repeat(3, minmax(0, 1fr))'
        columnGap={{ md: 10, lg: 16 }}
        flex='1'
        maxW='640px'
      >
        {LINK_GROUPS.map((group) => (
          <VStack key={group.titleId} align='stretch' spacing={4} textAlign='start'>
            <Text fontWeight='bold' color={HEADING}>
              <FormattedMessage id={group.titleId} defaultMessage={group.defaultTitle} />
            </Text>
            <VStack align='stretch' spacing={3}>
              {group.links.map((link) => (
                <FooterLinkItem key={link.labelId} link={link} />
              ))}
            </VStack>
          </VStack>
        ))}
      </Grid>
    </Flex>

    <Box mt={12}>
      <Copyright />
    </Box>
  </Flex>
);
